import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  CONTRACTS_LIST_PERMISSION,
  LEASING_CONTRACTS_PATH,
  LEASING_ORDER_PIPELINE_PATH,
} from '&/features/leasing/paths';

// `/leasing` has no page of its own. It lands on Contracts, the first shipped Leasing page — but only for a
// user who can open it (`contracts:list`). A user without it (e.g. a Location Manager) is sent to the first
// other Leasing page instead, which breaks the loop with the contract routes: they bounce a user without
// `contracts:list` here, so here must not bounce them back to a contracts route (SWOOP-345). Until
// permissions resolve on a hard refresh, land on Contracts; the contracts route lets an unresolved user
// through too, so there is no premature bounce.
export const Route = createFileRoute('/_authenticated/leasing/')({
  beforeLoad: ({ context }): void => {
    const { hasPermission, isReady } = context.permissions;
    if (isReady && !hasPermission(CONTRACTS_LIST_PERMISSION)) {
      throw redirect({ to: LEASING_ORDER_PIPELINE_PATH });
    }
    throw redirect({ to: LEASING_CONTRACTS_PATH });
  },
});
